/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Rekam_S2Inputs */

const en_tut_rekam_s2 = /** @type {(inputs: Tut_Rekam_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The host presses **Mulai rekaman** and confirms in the **Rekam rapat ini?** dialog.`)
};

const id_tut_rekam_s2 = /** @type {(inputs: Tut_Rekam_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Host menekan **Mulai rekaman**, lalu mengonfirmasi pada dialog **Rekam rapat ini?**.`)
};

/**
* | output |
* | --- |
* | "The host presses **Mulai rekaman** and confirms in the **Rekam rapat ini?** dialog." |
*
* @param {Tut_Rekam_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_rekam_s2 = /** @type {((inputs?: Tut_Rekam_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Rekam_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_rekam_s2(inputs)
	return en_tut_rekam_s2(inputs)
});